import { css } from 'linaria';
import { CarouselDirection } from './carousel.types';
import { root as itemRoot } from './carousel-item.styles';

export const root = css`
    list-style: none;
    display: flex;
    position: relative;
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    overscroll-behavior: contain;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;

const rowDirection = css`
    overflow-x: auto;
    overflow-y: hidden;
    flex-direction: row;

    scroll-snap-type: x mandatory;

    & > .${itemRoot} {
        touch-action: pan-x;
    }
`;

const columnDirection = css`
    overflow-y: auto;
    overflow-x: hidden;
    flex-direction: column;

    scroll-snap-type: y mandatory;

    & > .${itemRoot} {
        touch-action: pan-y;
    }
`;

export const directionVariants: Record<CarouselDirection, string> = {
    row: rowDirection,
    column: columnDirection,
};

export const indicatorContainer = css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 12px 0;
`;

export const indicatorButton = css`
    appearance: none;
    border: none;
    background: transparent;
    height: 1em;
    width: 1em;
    background: var(--carousel-indicator-color, rgba(0, 0, 0, var(--carousel-indicator-active, 0.5)));
    border-radius: 50%;
    padding: 0;
    margin: 0 12px;
    opacity: 0.5;
    transform: scale(1);
    transition: all 0.25s cubic-bezier(0.5, 0, 0.7, 1.5);

    &:hover,
    &:focus-visible {
        --carousel-indicator-active: 0.75;
    }

    &[aria-pressed='true'] {
        --carousel-indicator-active: 1;
        opacity: 1;
        transform: scale(1.45);
    }
`;

export const indicatorInverse = css`
    --carousel-indicator-color: rgba(255, 255, 255, var(--carousel-indicator-active, 0.5));
`;
